import React from "react";
import About from "../about";
import Map from "../agent";
import Rooms from "../rooms";
import Tooltip from "../tooltip";
import { useState } from "react";
import styles from "./header_menu.module.css";
import CancelBooking from "../cancel_booking";
import { useTranslation } from "react-i18next";

export default function HeaderMenu({ property = {} }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  const [showPropertyInfo, setPropertyInfo] = useState(false);
  const [showBookingModal, setShowBookingModal] = useState(false);

  const handleModalClose = () => {
    setIsModalOpen(false);
  };
  const handleEmailClick = () => {
    if (property?.email) {
      const email = property?.email;
      const subject = encodeURIComponent("Booking Inquiry");
      const body = encodeURIComponent("Hello, I would like to inquire about booking.");
      const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;

      // Redirect the current tab to the mailto link
      window.location.href = mailtoLink;
    }
  };

  return (
    <>
      <ul className={styles.menuList}>
        <li>
          <a onClick={() => setPropertyInfo(true)} type="button">
            {t("hotel_page:hotel_info")}
          </a>
        </li>

        <li>
          <a href="#map_section" onClick={() => setIsModalOpen(true)} type="button">
            {t("hotel_page:agents")}
          </a>
        </li>
        <li>
          <a onClick={() => setShowBookingModal(true)} type="button">
            {t("hotel_page:modify_booking")}
          </a>
        </li>
        {property?.email && (
          <li>
            <a type="button" onClick={handleEmailClick}>
              {t("hotel_page:contact")}
            </a>
          </li>
        )}
      </ul>
      <Tooltip property={property}></Tooltip>
      <Map
        member={isModalOpen}
        setMember={setIsModalOpen}
        handleModalClose={handleModalClose}
      ></Map>
      <About property={property} showModal={showPropertyInfo} setShowModal={setPropertyInfo} />
      <CancelBooking
        showModal={showBookingModal}
        setShowModal={setShowBookingModal}
        property={property}
      ></CancelBooking>
    </>
  );
}
